import React, { useState, useEffect, useRef } from 'react';
import DesktopUserNav from '../App-Components/DesktopUserNav'
import { IoIosArrowDown } from "react-icons/io";
import { MdNotificationsNone } from "react-icons/md";
import { NavLink } from 'react-router-dom';
import logo from "../../stock/nexus/logo.png"
import { CgMenuLeft } from "react-icons/cg";
import UserNav from '../App-Components/MobileUserNav';
import { FiEdit } from "react-icons/fi";

import { FiCopy, FiCheck } from "react-icons/fi";



import { RiExchangeDollarLine } from "react-icons/ri";
import { BiTransfer } from "react-icons/bi";
import { RiSendPlaneLine } from "react-icons/ri";
import { MdFormatListBulletedAdd } from "react-icons/md";

import { auth, txtdb } from '../../firebase-config';
import { doc, collection, getDoc, updateDoc, setDoc, deleteDoc } from "firebase/firestore";
import { getDocs, query, orderBy } from "firebase/firestore";
import { FaArrowLeft } from "react-icons/fa";
import { FaArrowRight } from "react-icons/fa";

import {
  onAuthStateChanged,
} from "firebase/auth";
import { IoIosArrowForward } from "react-icons/io";
import { LuCalendarClock } from "react-icons/lu";
import { BsArrowRight } from "react-icons/bs";
import { LuDot } from "react-icons/lu";
import { PiHandSwipeLeft } from "react-icons/pi";
import { useNavigate } from 'react-router-dom';

function User() {

  const [user, setUser] = useState({});
 const navigate = useNavigate();

    // State to track if the sidebar is visible
    const [isSidebarVisible, setIsSidebarVisible] = useState(false);

    // Function to handle the click event
    const handleNavClick = () => {
      setIsSidebarVisible(!isSidebarVisible); // Toggle sidebar visibility
    };

    //

    const [menuVisible, setMenuVisible] = useState(false);
    const menuRef = useRef(null);

      // Toggle menu visibility when button is clicked
  const handleToggleMenu = () => {
    setMenuVisible(!menuVisible);
  };

  // Close the menu when clicking outside
  const handleClickOutside = (event) => {
    if (menuRef.current && !menuRef.current.contains(event.target)) {
      setMenuVisible(false);
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);



  

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
      setUser(currentUser || null); // Ensures `user` is set to null if `currentUser` is null
    });
  
    // Cleanup function to unsubscribe from the listener when component unmounts
    return () => unsubscribe();
  }, [auth]);


  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
      if (currentUser) {
        // console.log("User is logged in:", currentUser);
        setUser(currentUser);
         
      } else {
        // console.log("No user is logged in.");
        setUser(null);
      }
    });

    return () => unsubscribe(); // Cleanup subscription on component unmount
  }, []);

  useEffect(() =>{
    document.title= "My Nexus profile"

  })



  



      //transactions//
      const [transactions, setTransactions] = useState([]);
    
      const fetchTransactions = async () => {
        const currentUser = auth.currentUser;
        if (!currentUser) {
          console.log("User not logged in.");
          return;
        }
  
        const userId = currentUser.uid;
        const transactionsRef = collection(txtdb, "users", userId, "transactions");
  
        try {
          // Query the transactions, ordered by date (descending)
          const q = query(transactionsRef, orderBy("date", "desc"));
          const querySnapshot = await getDocs(q);
  
          // Map the query results into an array
          const transactionsList = querySnapshot.docs.map((doc) => ({
            id: doc.id,
            ...doc.data(),
          }));
  
          setTransactions(transactionsList); // Store transactions in state
        } catch (error) {
          console.error("Error fetching transactions: ", error);
        }
      };
  
  
      useEffect(() => {
        fetchTransactions();
      }); 


      //list of investments
      
    
        
     
      
      useEffect(() => {
        const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
          setUser(currentUser || null); // Ensures `user` is set to null if `currentUser` is null
        });
      
        // Cleanup function to unsubscribe from the listener when component unmounts
        return () => unsubscribe();
      }, [auth]);
      
      
      
    
      
    
      
    
      const scrollRef = useRef(null);

      const scrollLeft = () => {
        if (scrollRef.current) {
          scrollRef.current.scrollBy({ left: -400, behavior: 'smooth' });
        }
      };
    
      const scrollRight = () => {
        if (scrollRef.current) {
          scrollRef.current.scrollBy({ left: 400, behavior: 'smooth' });
        }
      };
    

      //get user info

       const [userData, setUserData] = useState(null);

useEffect(() => {
  const unsubscribe = onAuthStateChanged(auth, async (user) => {
    if (user) {
      const docRef = doc(txtdb, "kycInfo", user.uid);
      const docSnap = await getDoc(docRef);
      if (docSnap.exists()) {
        setUserData(docSnap.data());
      }
    } else {
      setUserData(null);
    }
  });

  return () => unsubscribe(); // clean up listener
}, []);


//   if (!userData) {
//     return <div className="review-container loading">Loading...</div>;
//   }
      
    function middleEllipsis(str, maxLength = 20) {
  if (str.length <= maxLength) return str;
  const part = Math.floor((maxLength - 3) / 2);
  return str.slice(0, part) + "..." + str.slice(-part);
}

  const [copied, setCopied] = useState(false);
  const uid = userData?.uid || auth.currentUser?.uid || "";

  const handleCopy = () => {
    if (!uid) return;
    navigator.clipboard.writeText(uid);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000); // reset after 2 seconds
  };


  return (
    <div className='layout'>
      <DesktopUserNav />

      <div className="dashboard-container content">

      <div className="container" >

      <div className="navigation-container">

      <NavLink to='/dashboard' className="mobile">
                <img src={logo} alt="keystonecapitals" />
                <p className='name'>{user.displayName}</p>
      </NavLink>


       <p className='desktop'>Welcome, {user.displayName}</p>

       <div className="actions desktop" >

        <div className="quick" onClick={handleToggleMenu} >
        Quick Actions 
        <IoIosArrowDown />

        {menuVisible && (
                         <div className="quick-actions" ref={menuRef}>

                         <NavLink to="/withdrawals" className="settings top">
                             <RiSendPlaneLine className='icon' /> Send Money
                         </NavLink>
     
                         <NavLink to="/trades" className="settings">
                             <MdFormatListBulletedAdd  className='icon' /> New Trade
                         </NavLink>
     
                         <NavLink to="/deposits" state={{ currentPage: "convert" }} className="settings">
                             <RiExchangeDollarLine  className='icon'/> Convert Funds
                         </NavLink>
     
                         <NavLink to="/deposits" className="logout">
                             <BiTransfer  className='icon' /> Fund Wallet
                         </NavLink>
     
                         </div>
                )}
        </div>

       <div className="notif">
       <MdNotificationsNone className='icon' />
       </div>
       </div>

       <div className="actions mobile">

       <div className="notif">
       <MdNotificationsNone className='icon' />
       </div>

       <div className="nav"  onClick={handleNavClick}>
       <CgMenuLeft className='icon' />
       </div>

       </div>

      </div>

      {isSidebarVisible && (
        <UserNav onClose={handleNavClick} />
      )}

      </div>

     <div className="user-profile">
       <div className="review-page">
      <div className="review-container">
        <h2 className="title">Review your information</h2>
        <p className="subtitle">
           Here’s a summary of the information you’ve shared with us.
        </p>

        <div className="review-card">
          <div className="card-header">
         <h3>User Details</h3>
            {/* <span className="edit" onClick={() => navigate("/kyc")}>
              <FiEdit /> Edit
            </span> */}
          </div>

            <div className="info-list">
                <div className="info-item">
            <p>ID</p>
            <div
                className="flex items-center gap-1 cursor-pointer select-none"
                onClick={handleCopy}
                >
                <span>
                    {userData ? middleEllipsis(uid, 17) : <span className="skeleton"></span>}
                </span>
                {userData && (
                    copied ? (
                    <FiCheck className="copied" />
                    ) : (
                    <FiCopy className="copied" />
                    )
                )}
                </div>

            </div>

            <div className="info-item">
                <p>First name</p>
                <span>{userData ? userData.firstName : <span className="skeleton"></span>}</span>
            </div>
            <div className="info-item">
                <p>Last name</p>
                <span>{userData ? userData.lastName : <span className="skeleton"></span>}</span>
            </div>
            <div className="info-item">
                <p>Email address</p>
               <span>
                {auth.currentUser?.email
                    ? middleEllipsis(auth.currentUser.email, 17)
                    : <span className="skeleton"></span>}
                </span>

            </div>
            <div className="info-item">
                <p>ID type</p>
                <span>{userData ? userData.idType : <span className="skeleton"></span>}</span>
            </div>
            <div className="info-item">
                <p>ID number</p>
                <span>{userData ? userData.idNumber : <span className="skeleton"></span>}</span>
            </div>
            <div className="info-item">
                <p>Date of birth</p>
                <span>{userData ? userData.dob : <span className="skeleton"></span>}</span>
            </div>
            <div className="info-item">
                <p>Gender</p>
                <span>{userData ? userData.gender : <span className="skeleton"></span>}</span>
            </div>
            <div className="info-item">
                <p>Country</p>
                <span>{userData ? userData.country : <span className="skeleton"></span>}</span>
            </div>
            <div className="info-item">
                <p>Phone number</p>
                <span>{userData ? userData.phone : <span className="skeleton"></span>}</span>
            </div>
            </div>

        </div>

        <div className="actions">
          {/* <button className="back" onClick={() => navigate("/kyc")}>
            Back
          </button>
          <button className="complete" onClick={() => navigate("/username")}>
            Complete
          </button> */}
         You can’t edit your information at the moment.
        </div>
      </div>
    </div>
     </div>



      </div>

     



    </div>
  )
}

export default User